import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    formattedTimeToday: (relativeTime?: string, time?: string) => string;
    formattedTimeBeforeToday: ({ relativeTime, time, date }: {
        relativeTime?: string;
        time?: string;
        date: Date;
    }) => string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Formats relative timestamp for today */
            formattedTimeToday: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (relativeTime?: string, time?: string): string => { return __intl__.intl().formatMessage({ id: "GetScreenReaderTextForTimestamp.formattedTimeToday.0?c=z3s2ppgrjfob", defaultMessage: "{relativeTime} ago at {time}" }, { relativeTime: relativeTime, time: time }); });
                },
                enumerable: true,
                configurable: true
            },
            /** Formats relative timestamp for before today */
            formattedTimeBeforeToday: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => ({ relativeTime, time, date }: {
                        relativeTime?: string;
                        time?: string;
                        date: Date;
                    }): string => { return __intl__.intl().formatMessage({ id: "GetScreenReaderTextForTimestamp.formattedTimeBeforeToday.0?c=3mhiav6sgfui3", defaultMessage: "{relativeTime} ago at {time} on {date, date, medium}" }, { relativeTime: relativeTime, time: time, date: date }); });
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
